import {Pjax} from '@lib/../services/navigation/Pjax';
import anime from 'animejs';
import {ConnectedComponent} from 'lowkey-component';

import {sleep} from '@lib/utils';
import {peopleSelectors} from '@store/peopleSlice';

export class PeopleList extends ConnectedComponent {
  params: URLSearchParams | null = null;
  button: HTMLButtonElement | null = null;
  buttonLabel: HTMLDivElement | null = null;

  constructor(element: HTMLDivElement) {
    super(element);
    this.onClick = this.onClick.bind(this);
  }

  didMount() {
    this.button = document.querySelector(
      '.o-people-filter_button .a-button',
    ) as HTMLButtonElement;

    this.button.addEventListener('click', this.onClick);
    this.buttonLabel = this.button?.querySelector(
      '.a-button_label',
    ) as HTMLDivElement;

    this.params = new URLSearchParams(location.search);
    this.observe(peopleSelectors.selectOccupation, (state) => {
      this.params?.set('occupation', state);
    });
    this.observe(peopleSelectors.selectIntentionality, (state) => {
      this.params?.set('intentionality', state);
    });
    this.observe(peopleSelectors.selectJoinType, (state) => {
      this.params?.set('join_type', state);
    });
  }

  didUnmount() {
    this.button?.removeEventListener('click', this.onClick);
  }

  async onClick() {
    const baseUrl = `${location.origin}${location.pathname}`;
    const url = `${baseUrl}?${this.params?.toString()}`;

    const defaultText = this.buttonLabel?.textContent || '';
    this.buttonLabel && (this.buttonLabel.textContent = '読み込み中...');
    this.button && (this.button.disabled = true);
    const res = await this.fetch(url);
    this.attach(res);
    await sleep(700);
    this.buttonLabel && (this.buttonLabel.textContent = defaultText);
    this.button && (this.button.disabled = false);
  }

  async fetch(url: string) {
    const response = await fetch(url, {
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'GET',
    });
    if (!response.ok) {
      throw new Error(response.statusText);
    }
    const htmlText = await response.text(); // JSON のレスポンスをネイティブの JavaScript オブジェクトに解釈
    // Convert the HTML string into a document object
    const parser = new DOMParser();
    return parser.parseFromString(htmlText, 'text/html');
  }

  attach(res: Document) {
    this.element.innerHTML = '';
    const items = [
      ...res.querySelectorAll('.o-people-list_item'),
    ] as HTMLDivElement[];

    const pjax = Pjax.create();
    items.map((item) => {
      const textList = [...item.querySelectorAll('.js-text')];
      textList.map((text) => {
        text.classList.remove('js-text');
      });
      const image = item.querySelector('.js-image');
      image?.classList.add('viewed');
      this.element.appendChild(item);
      pjax.refresh(item);
      anime({
        duration: 400,
        easing: 'easeInOutCubic',
        opacity: [0, 1],
        targets: item,
      });
    });
    if (items.length === 0) {
      const empty = document.createElement('div');
      empty.classList.add('o-people-list_empty');
      empty.textContent = '該当者なし';
      this.element.appendChild(empty);
    }
  }
}
